import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import {greys} from "@irati/ui/src/global/colors"
import {twoPxShadow} from "@irati/ui/src/global/elevation"

const Container = styled.div`
  border-radius: 4px;
  background-color: ${greys.white};
  ${twoPxShadow}
  padding: 15px;
  position: relative;
  display: inline-block;

  &:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    ${({arrowPosition, arrowSize}) => (arrowPosition === "top") && `
      top: -${arrowSize}px;
      left: calc(50% - ${arrowSize / 2}px);
      border-width: ${arrowSize}px 0 0 ${arrowSize}px;
      border-color: transparent transparent transparent ${greys.white};
    `}
    ${({arrowPosition, arrowSize}) => (arrowPosition === "right") && `
      top: calc(50% - ${arrowSize / 2}px);
      left: calc(100% - 1px);
      border-width: ${arrowSize}px ${arrowSize}px 0 0;
      border-color: ${greys.white} transparent transparent transparent;
    `}
    ${({arrowPosition, arrowSize}) => (arrowPosition === "bottom") && `
      top: 100%;
      left: calc(50% - ${arrowSize / 2}px);
      border-width: 0 ${arrowSize}px ${arrowSize}px 0;
      border-color: transparent ${greys.white} transparent transparent;
    `}
    ${({arrowPosition, arrowSize}) => (arrowPosition === "left") && `
      top: calc(50% - ${arrowSize / 2}px);
      left: -${arrowSize - 1}px;
      border-width: 0 0 ${arrowSize}px ${arrowSize}px;
      border-color: transparent transparent ${greys.white} transparent;
    `}
  }
`

const InfoWindow = ({children, arrowSize, arrowPosition, className}) => {
  return (
    <Container arrowSize={arrowSize} arrowPosition={arrowPosition} className={className}>
      {children}
    </Container>
  )
}

InfoWindow.propTypes = {
  children: PropTypes.any,
  arrowSize: PropTypes.number,
  arrowPosition: PropTypes.oneOf([
    "top",
    "right",
    "bottom",
    "left"
  ]),
  className: PropTypes.string
}

InfoWindow.defaultProps = {
  children: null,
  arrowSize: 30,
  arrowPosition: "top",
  className: null
}

export default InfoWindow
